import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { state: { user: res.data }, replace: true });
      })
      .catch(() => navigate("/auth", { replace: true }));
  }, [navigate, setUser]);

  return (
    <main className="pt-[72px] min-h-screen grid place-items-center">
      <p className="font-mono2 text-xs uppercase text-slate-500">…</p>
    </main>
  );
}
